export default "__VITE_ASSET__BczH2z31__"